import { DecisionHistoryRecordV2 } from "src/api/decisionHistoryV2/decisionHistoryQueries";
import { FlowVersion } from "src/api/flowTypes";
import { useFlowVersion } from "src/api/flowVersionQueries";
import { LoadingView } from "src/base-components/LoadingView";
import { NodeTypes } from "src/clients/flow-api";
import { PendingManualReviewOutput } from "src/decisionsOverview/PendingManualReviewOutput";
import { findPendingNode } from "src/decisionsOverview/utils";
import { Callout } from "src/design-system/Callout";
import { useWorkspaceContext } from "src/router/routerContextHooks";
import { LeftPaneOptions } from "src/router/SearchParams";
import {
  getBaseUrl,
  getUrlToAuthoringPage,
  UrlToAuthoringPageOptions,
} from "src/router/urls";

export const PendingOutputTabContent: React.FC<{
  decision: DecisionHistoryRecordV2;
}> = ({ decision }) => {
  const { orgId, workspace } = useWorkspaceContext();
  const flowVersionQuery = useFlowVersion(decision.flow.version_id);
  return (
    <LoadingView
      queryResult={flowVersionQuery}
      renderUpdated={(flowVersion: FlowVersion) => {
        if (flowVersion.graph) {
          const pendingNode = findPendingNode(
            decision,
            flowVersion.graph.nodes,
            flowVersion.graph.edges,
          );
          if (pendingNode?.type === NodeTypes.REVIEW_CONNECTION_NODE) {
            return (
              <PendingManualReviewOutput
                decision={decision}
                node={pendingNode}
              />
            );
          }
          if (pendingNode) {
            return (
              <div className="px-4">
                <Callout
                  action={{
                    text: "View Node",
                    onClick: () => {
                      const params: UrlToAuthoringPageOptions = {
                        selectedNodeId: pendingNode.id,
                        decisionId: decision.id,
                        leftPane: LeftPaneOptions.DecisionHistory,
                      };
                      const url =
                        getBaseUrl() +
                        getUrlToAuthoringPage(
                          orgId,
                          workspace.id,
                          decision.flow.id,
                          flowVersion.id,
                          params,
                        );
                      window.open(url, "_blank");
                    },
                  }}
                  variant="success"
                >
                  <p>
                    Waiting for the response from {pendingNode.name} to complete
                    this decision
                  </p>
                </Callout>
              </div>
            );
          }
        }
        return <></>;
      }}
    />
  );
};
